module.exports = __webpack_public_path__ + "static/media/light_rightAngle.74aed86c.svg";